import React from 'react';

export const ContactDetails = (props) => (
  <svg
    fill="none"
    height="24"
    id="contactsIcon"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M17.25 6C17.25 8.8995 14.8995 11.25 12 11.25C9.10051 11.25 6.75 8.8995 6.75 6C6.75 3.10051 9.10051 0.75 12 0.75C14.8995 0.75 17.25 3.10051 17.25 6Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M2.75 20.666C2.75 19.7299 3.40312 18.258 4.94465 16.9924C6.45783 15.7501 8.78665 14.75 12 14.75C15.2134 14.75 17.5422 15.7501 19.0553 16.9924C20.5969 18.258 21.25 19.7299 21.25 20.666V22C21.25 22.3315 21.1183 22.6495 20.8839 22.8839C20.6495 23.1183 20.3315 23.25 20 23.25H4C3.66848 23.25 3.35054 23.1183 3.11612 22.8839C2.8817 22.6495 2.75 22.3315 2.75 22V20.666Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect fill="white" height="24" width="24" />
      </clipPath>
    </defs>
  </svg>
);
